<script>
    import {store} from '../stores.js';
    import storage from '../storage.js';

    const user = store('credential', 'getAuth');
    const year = (new Date()).getFullYear();

    const logout = () => {
        user.remove();
        storage.clear();
        location.href = '/';
    };
</script>

<!-- App about -->
<div class="section full mt-2">
    <img src="/findir24.png" alt="image" class="imaged square d-block mx-auto" style="width: 100%;max-width: 200px;height: auto;">
</div>

<div class="section full mt-2" style="font-size: 11px; line-height: 1.2em;">
    <div class="text-center text-muted">
        v{APP_VERSION} (build: {COMMIT_SHA})<br>[type: {APP_TYPE}]
    </div>
</div>

<div class="section full mt-2">
    <div class="section-title">Функции</div>
    <div class="wide-block pt-2 pb-1">
        <p>
            ✅ Создание заявок на оплату
        </p>
        <p>
            ✅ Контроль статуса
        </p>
    </div>
</div>

<div class="section full mt-2 mb-5" style="font-size: 11px; line-height: 1.2em;">
    <div class="text-center">
        <div class="row">
            <div class="col-6">
                {#if $user.id > 0}<div on:click={logout}>{$user.name}<br>{$user.email} [{$user.id}]</div>{/if}
            </div>
            <div class="col-6">
                Copyright © {(new Date).getFullYear()}<br><a href="https://u4et.ru" target="_blank">u4et.ru</a>
            </div>
        </div>
    
    </div>
</div>
<!-- * App about -->
